<template>
  <BreadCrumb PageTitle="Tableau de bord Agent" />
  <AgentDashboard />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AgentDashboard from "../../components/Agent/AgentDashboard.vue";

export default defineComponent({
  name: "AgentDashboardPage",
  components: {
    BreadCrumb,
    AgentDashboard,
  },
});
</script>